import useColors from 'hooks/useColors';
import React from 'react';
import { Path, Svg } from 'react-native-svg';
export const BUBBLE_ARROW_WIDTH = 13;
const WalkthroughBubbleArrow = ({ style }) => {
    const colors = useColors();
    return (<Svg width={BUBBLE_ARROW_WIDTH} height="11" viewBox="0 0 13 11" fill="none" style={style}>
      <Path d="M6.06218 0L12.1244 10.5L0 10.5L6.06218 0Z" fill={colors.cards.onDark}/>
    </Svg>);
};
export default WalkthroughBubbleArrow;
